import { render, staticRenderFns } from "./ChatButton.vue?vue&type=template&id=2dbd2655&"
import script from "./ChatButton.vue?vue&type=script&lang=js&"
export * from "./ChatButton.vue?vue&type=script&lang=js&"
import style0 from "./ChatButton.vue?vue&type=style&index=0&id=2dbd2655&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports